import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { initSentry } from './lib/sentry'
import { installGoogleTranslateDomCompatibility } from './lib/i18n/googleTranslateDomCompatibility'
import './index.css'
import App from './App.tsx'

// Google Translate muta los nodos de texto que React controla. Instalamos la
// compatibilidad antes de montar la aplicación para evitar fallos al actualizar.
installGoogleTranslateDomCompatibility()

// Inicializar Sentry lo antes posible
initSentry()

// Crear cliente de React Query con configuración optimizada
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos
      gcTime: 10 * 60 * 1000, // 10 minutos (anteriormente cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
    mutations: {
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </StrictMode>,
)
